'use strict';
define(["../g2"],function(g2){
    /**
     * 模式
     **/
    var PATTERNS={
        //文本
        'TEXT':'text',
        //引线标注
        'TAILEDTEXT':'tailedtext',
        //点
        'POINT':'point',
        //线
        'POLYLINE':'line',
        //面
        'POLYGON':'polygon',
        //复合
        'COMPOSITE':'composite',
        //动图
        'OVERLAY': 'overlay',
    }
    /**
     * 标绘类型
     * key值去掉Algorithm后缀
     *
     * 后续需要补全所有的标绘（算法）类型
     **/
    var g2=g2||{};
    g2.algm=g2.algm||{};
    /**
     * @namespace
     * @description 标绘类型定义
     * @alias G.plot.TYPES
     */
    var TYPES={
        /**
         * 文本
         */
        Text:{
            title:'文本',
            algorithm:'PointAlgorithm',
            type:PATTERNS.TEXT
        },
        TAILEDTEXT:{
            title:'文本',
            algorithm:'PointAlgorithm',
            type:PATTERNS.TAILEDTEXT
        },
        /**
         * 点状标绘
         */
        Point:{
            title:'点',
            algorithm:'PointAlgorithm',
            type:PATTERNS.POINT
        },
        Overlay:{
            title:'动图',
            algorithm:'PointAlgorithm',
            type:PATTERNS.POINT
        },
        /**
         * 线状标绘
         */
        Polyline:{
            title:'折线',
            algorithm:'PolylineAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 曲线
         */
        Curve:{
            title:'曲线',
            algorithm:'CurveAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 弧线
         */
        Camber:{
            title:'弧线',
            algorithm:'CamberAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 自由标绘线
         */
        FreePolyline:{
            title:'自由标绘线',
            algorithm:'FreePolylineAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 多边形
         */
        Polygon:{
            title:'多边形',
            algorithm:'PolygonAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 圆
         */
        Circle:{
            title:'圆',
            algorithm:'CircleAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 矩形
         */
        Rectangle:{
            title:'矩形',
            algorithm:'RectangleAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 椭圆
         */
        Ellipse:{
            title:'椭圆',
            algorithm:'EllipseAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 扇形
         */
        Sector:{
            title:'扇形',
            algorithm:'SectorAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 圆弧
         */
        Arc:{
            title:'圆弧',
            algorithm:'ArcAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 封闭曲线
         */
        CloseCurve:{
            title:'封闭曲线',
            algorithm:'CloseCurveAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 自由标绘面
         */
        FreePolygon:{
            title:'自由标绘面',
            algorithm:'FreePolygonAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 双箭头
         */
        DoubleArrow:{
            title:'双箭头',
            algorithm:'DoubleArrowAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 燕尾箭头
         */
        SwallowTailArrow:{
            title:'燕尾箭头',
            algorithm:'SwallowtailArrowAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 多箭头
         */
        MultiArrow:{
            title:'多箭头',
            algorithm:'MultiArrowAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 细直箭头
         */
        BeelineArrow:{
            title:'细直箭头',
            algorithm:'BeelineArrowAlgorithm',
            // algorithm:'BeelineArrowAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 单曲箭头
         */
        CurveArrow:{
            title:'单曲箭头',
            algorithm:'CurveArrowAlgorithm',
            // algorithm:'CurveArrowAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 单箭头
         */
        SimpleArrow:{
            title:'单箭头',
            algorithm:'SimpleArrowAlgorithm',
            type:PATTERNS.POLYGON
        },
        /**
         * 直箭头
         */
        SlightnessArrow:{
            title:'直箭头',
            algorithm:'SlightnessArrowAlgorithm',
            // algorithm:'SlightnessArrowProperty2',
            type:PATTERNS.POLYGON
        },
        /**
         * 突击方向
         */
        ShockWay:{
            title:'突击方向',
            algorithm:'ShockWayAlgorithm',
            // algorithm:'ShockWayProperty',
            type:PATTERNS.POLYGON
        },
        /**
         * 武警
         */
        Arsenal:{
            title:'武警',
            algorithm:'ArsenalProperty',
            // algorithm:'ArsenalAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 专家
         */
        ExpertProtect:{
            title:'专家',
            algorithm:'ExpertProtectAlgorithm',
            // algorithm:'ExpertProtectAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 工程
         */
        Engineer:{
            title:'工程',
            algorithm:'PowerRepairAlgorithm',
            // algorithm:'ProjectAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 军队
         */
        Army:{
            title:'军队',
            algorithm:'ArmyAlgorithm',
            // algorithm:'ArmyAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 消防
         */
        FireProtect:{
            title:'消防',
            algorithm:'FireProtectAlgorithm',
            // algorithm:'FireProtectAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 医疗
         */
        MedicalCure:{
            title:'医疗',
            algorithm:'MedicalCureAlgorithm',
            // algorithm:'MedicalCureAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 电力抢修
         */
        PowerRepair:{
            title:'电力抢修',
            algorithm:'PowerRepairAlgorithm',
            // algorithm:'PowerRepairAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 防化
         */
        ProChymic:{
            title:'防化',
            algorithm:'ProchymicAlgorithm',
            // algorithm:'ProChymicAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 专业救援
         */
        ProSuccor:{
            title:'专业救援',
            algorithm:'ProsuccorAlgorithm',
            // algorithm:'ProSuccorAlgorithm2',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 空中运输
         */
        AirWay:{
            title:'空中运输',
            algorithm:'AirwayAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 炮弹路线
         */
        Cannon:{
            title:'炮弹路线',
            algorithm:'CannonAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 空中机动
         */
        AirMobile:{
            title:'空中机动',
            algorithm:'AirMobileAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 高射炮兵营地
         */
        ArtilleryManenCampment:{
            title:'高射炮兵营地',
            algorithm:'ArtilleryManenCampmentAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 摩托化行军纵队
         */
        MotorbikeTeam:{
            title:'摩托化行军纵队',
            algorithm:'MotorbikeTeamAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 防空兵行军纵队
         */
        AntiairCraftForces:{
            title:'防空兵行军纵队',
            algorithm:'AntiAirCraftForceAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 坦克及步战车进攻队形
         */
        TankAndMusketer:{
            title:'坦克及步战车进攻队形',
            algorithm:'TankAndMusketerAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 进攻队形
         */
        AttackOrder:{
            title:'进攻队形',
            algorithm:'AttackOrderAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 由进攻转入防守2
         */
        AttackTurnDefend2:{
            title:'由进攻转入防守2',
            algorithm:'AttackTurnDefend2Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 由进攻转入防守1
         */
        AttackTurnDefend1:{
            title:'由进攻转入防守1',
            algorithm:'AttackTurnDefend1Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 炮兵行军纵队
         */
        Artillery:{
            title:'炮兵行军纵队',
            algorithm:'ArtilleryAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 侦查搜索
         */
        RecceSearch:{
            title:'侦查搜索',
            algorithm:'RecceSearchAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 流动哨
         */
        Patroller:{
            title:'流动哨',
            // algorithm:'PatrollerAlgorithm',
            algorithm:'PatrolLeralAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 坦克营进攻队形
         */
        TankAttack:{
            title:'坦克营进攻队形',
            algorithm:'TankAttackAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 步兵战斗车连
         */
        Musketry:{
            title:'步兵战斗车连',
            algorithm:'MusketryAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 水上救援舰艇
         */
        NavalShips:{
            title:'水上救援舰艇',
            algorithm:'NavalShipsAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 救援车辆纵队
         */
        PedrailColumn:{
            title:'救援车辆纵队',
            algorithm:'PedrailColumnAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 输油管线
         */
        PipeLaying:{
            title:'输油管线',
            algorithm:'PipeLayingAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 警戒区域
         */
        PolygonText:{
            title:'警戒区域',
            algorithm:'PolygonTextAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 铁路输送
         */
        Railage:{
            title:'铁路输送',
            algorithm:'RailAgeAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 海上搜救队形
         */
        RoundsLine:{
            title:'海上搜救队形',
            algorithm:'RoundsLineAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 通信光缆线路
         */
        CommunicateLine:{
            title:'通信光缆线路',
            algorithm:'CommunicateLineAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 隔离线1
         */
        PatrolLine:{
            title:'隔离线1',
            algorithm:'PatrolLineAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 隔离线2
         */
        WarBoundary:{
            title:'隔离线2',
            algorithm:'WarBoundaryAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 海上封锁线
         */
        FinderLine:{
            title:'海上封锁线',
            algorithm:'FinderLineAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 固定输油管线
         */
        FixedPipeLaying:{
            title:'固定输油管线',
            algorithm:'FixedPipeLayingAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 陆地机动技术
         */
        LandMobile:{
            title:'陆地机动技术',
            algorithm:'LandMobileAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 警戒线
         */
        ForbidFlyLine:{
            title:'警戒线',
            algorithm:'ForbidFlyLineAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 大型输电线路
         */
        LineAbatis3:{
            title:'大型输电线路',
            algorithm:'LineAbatis3Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 中型输电线路
         */
        LineAbatis2:{
            title:'中型输电线路',
            algorithm:'LineAbatis2Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 小型输电线路
         */
        LineAbatis1:{
            title:'小型输电线路',
            algorithm:'LineAbatis1Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 生态隔离线
         */
        LaighStake:{
            title:'生态隔离线',
            algorithm:'LaighstakeAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 直升机输送
         */
        HelicopterTransport:{
            title:'直升机输送',
            algorithm:'HelicopterTransportAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 事故车辆行进路线
         */
        MissileMarch:{
            title:'事故车辆行进路线',
            algorithm:'MissileMarchAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 公路运输
         */
        HighWay:{
            title:'公路运输',
            algorithm:'HighwayAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 灾民撤离
         */
        MusketerByTank:{
            title:'灾民撤离',
            algorithm:'MusketerByTankAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 专业救援队形2
         */
        TankMusColumn:{
            title:'专业救援队形2',
            algorithm:'TankMusColumnAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 危险路段
         */
        Trench:{
            title:'危险路段',
            algorithm:'TrenchAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 水路运输
         */
        Waterage:{
            title:'水路运输',
            algorithm:'WaterAgeAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 集结区域
         */
        RendezvousArea1:{
            title:'集结区域',
            algorithm:'RendezvousArea1Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 事故区域蔓延
         */
        RendezvousArea2:{
            title:'事故区域蔓延',
            algorithm:'RendezvousArea2Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 事故区域控制
         */
        RendezvousArea3:{
            title:'事故区域控制',
            algorithm:'RendezvousArea3Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 物质集散地
         */
        RendezvousArea4:{
            title:'物质集散地',
            algorithm:'RendezvousArea4Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 空中救援队伍
         */
        OriginalBirth:{
            title:'空中救援队伍',
            algorithm:'OriginalBirthAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 海上机动技术
         */
        SeaMobile:{
            title:'海上机动技术',
            algorithm:'SeaMobileAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 在建铁路
         */
        Stake:{
            title:'在建铁路',
            algorithm:'StakeAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 支撑点2
         */
        UnderProp2:{
            title:'支撑点2',
            algorithm:'UnderProp2Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 支撑点3
         */
        UnderProp3:{
            title:'支撑点3',
            algorithm:'UnderProp3Algorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 要点
         */
        ImportantPlace:{
            title:'要点',
            algorithm:'ImportantPlaceAlgorithm',
            type:PATTERNS.COMPOSITE
        },
        /**
         * 遭破坏的线路
         */
        CurrentTaskLine:{
            title:'遭破坏的线路',
            algorithm:'CurrentTaskLineAlgorithm',
            type:PATTERNS.POLYLINE
        },
        /**
         * 遭破坏的道路
         */
        LatterTaskLine:{
            title:'遭破坏的道路',
            algorithm:'LatterTaskLineAlgorithm',
            type:PATTERNS.POLYLINE
        }
    };

    //分类的key值
    var TYPES_KEYS={};
    for(var k in TYPES){
        TYPES_KEYS[k]=k;
    }

    /**
     *
     */
    var COMMANDNAMES={
        'NoopTool':'NoopTool',
        'PlotEdit':'PlotEdit'
    }

    return {
        PATTERNS:PATTERNS,
        TYPES:TYPES,
        TYPES_KEYS:TYPES_KEYS,
        COMMANDNAMES:COMMANDNAMES
    };
});
